/**
 * Custom Hook: useAuth
 * Maneja la autenticación del usuario
 */

import { useState, useEffect, useCallback } from 'react';
import authService from '../services/authService';

export const useAuth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Verifica sesión al cargar
  useEffect(() => {
    checkSession();
  }, []);

  const checkSession = useCallback(() => {
    const currentUser = authService.getCurrentUser();
    
    if (currentUser) {
      setUser(currentUser);
      setIsAuthenticated(true);
    } else {
      setUser(null);
      setIsAuthenticated(false);
    }
    
    setLoading(false);
  }, []);

  const login = useCallback(async (username, password) => {
    setLoading(true);
    
    try {
      const result = await authService.login(username, password);
      
      if (result.success) {
        setUser(result.user);
        setIsAuthenticated(true);
        return { success: true, user: result.user };
      }
      
      return { success: false, error: result.error };
    } catch (error) {
      return { success: false, error: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(() => {
    authService.logout();
    setUser(null);
    setIsAuthenticated(false);
  }, []);

  const refreshSession = useCallback(() => {
    authService.refreshSession();
  }, []);

  return {
    user,
    isAuthenticated,
    loading,
    login,
    logout,
    refreshSession
  };
};

export default useAuth;
